var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('AlarmaNavar'),_c('BannerAlarma'),_c('CategoriasAlarma'),_c('AlarmaFqa'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }